module.exports = __webpack_public_path__ + "img/imgImgHome04.e22b76dc.svg";